
import React, { useState } from "react";
import moment from 'moment-jalaali'
import { Form, Button, Input, Space, Row, Tooltip, Col, Card, Table, message } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import StringHelper from '../helpers/StringHelper';
import strings from '../../utils/strings';
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { ZoomInOutlined } from "@ant-design/icons";
import CrmCallReasonModal from "../user-business-report/crmReport/crmCallHistory/crmCallReasonModal";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import DateObject from "react-date-object";

export default function MyCallHistories(params) {
    const general = useGeneralStore();
    const reports = useReportsStore()
    const today = new DateObject({ calendar: persian, locale: persian_fa });
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const buttonLoading = reports.crmDoneCallHistory.loading;
    const loading = reports.myCallHistories.loading;
    const data = reports.myCallHistories.data;
    const [searchedColumn, setSearchedColumn] = useState("");
    const [searchText, setSearchText] = useState("");
    const [id, setID] = useState();


    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        ریست
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        const params = {
            FromDate: convertToMoment(fromDate), //moment(values.fromDate).format('YYYY/MM/DD').replaceAll('/', '-'),
            ToDate: convertToMoment(toDate), //moment(values.toDate).format('YYYY/MM/DD').replaceAll('/', '-'),
        }
        if (!params.FromDate || !params.ToDate) {
            return message.error("لطفا مقادیر مربوط به تاریخ را اعمال کنید")
        }
        reports.getMyCallHistories({ param: params });
    }

    const layout = {
        lg: 6,
        md: 12,
        xs: 24
    }

    const columns = [
        {
            title: 'مشاهده',
            dataIndex: "operation",
            width: 80,
            key: "operation",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">

                        <Button type='link' htmltype="submit"
                            onClick={() => {
                                setID(record.Id)
                                reports.getCrmCallHistoryReason(record.Id);
                                general.ToggleCrmCallReasonModal(true);
                            }}>
                            <ZoomInOutlined />
                        </Button>

                    </Space>
                )
        },
        {
            title: 'روند تماس',
            dataIndex: "doneCall",
            ellipsis: true,
            width: 90,
            key: "doneCall",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        {record.CallStatus === 1 &&
                            <button
                                type="primary" htmltype="submit" className="btn btn-success waves-effect waves-light"
                                onClick={() => {
                                    reports.getCrmDoneCallHistory(record.Id);
                                    setTimeout(() => {
                                        reports.getMyCallHistories({ param: params });
                                    }, 1000);
                                }}>
                                <Tooltip placement="top" overlayClassName="wizard-tooltip" title="بسته">
                                    <i className={`${buttonLoading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle "`}></i>
                                </Tooltip>
                            </button>}
                    </Space>
                )
        },
        {
            title: 'کد تماس',
            dataIndex: 'Id',
            width: 60,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },
            ...getColumnSearchProps("UserName", "نام کاربری"),

        },
        {
            title: 'دلیل تماس',
            dataIndex: 'ReasonTitle',
            width: 160,
            key: 'ReasonTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'وضعیت تماس',
            dataIndex: 'CallStatusTitle',
            width: 110,
            key: 'CallStatusTitle',
        },
        {
            title: 'نوع تماس',
            dataIndex: 'CallTypeTitle',
            width: 110,
            key: 'CallTypeTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 130,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "کد رهگیری",
            dataIndex: "RequestNumber",
            key: "RequestNumber",
            width: 150,
            sorter: (a, b) => a.RequestNumber.localeCompare(b.RequestNumber),
        },


    ];


    return (
        <Card className="my-call-histories">
            <Form
                className="sale-filter"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{
                    fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                    toDate: params.toDate && moment(params.toDate)
                }}>

                <Row gutter={[8]}>

                    <Col {...layout}>
                        <label className="d-block has-before">از تاریخ</label>
                        <DatePicker
                            value={fromDate}
                            onChange={setFromDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input w-100"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Col>
                    <Col {...layout}>
                        <label className="d-block has-before">تا تاریخ</label>
                        <DatePicker
                            value={toDate}
                            onChange={setToDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input w-100"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Col>
                    <Col {...layout}>
                        <Form.Item label=" " colon={false}>
                            <button
                                style={{ marginTop: -10 }}
                                disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                                جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                            </button>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={columns}
                loading={loading}
                rowKey="Id"
                scroll={true}
                dataSource={data}
            />
            <CrmCallReasonModal callHistoryId={id} />
        </Card>
    )
}